import {Tr, TrSpace} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import PlayerStore from "@/store/player";
import {CampaignType, StatusDto} from "@/store/player/types";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import {BoosterType, ShopCreature} from "@/store/shop/types";
import ShopStore from "@/store/shop";
import CU from "@/utils/c-u";
import {CampaignCreaturePanel} from "@/scenes.ui/campaign-creature-panel";
import {StringUtils} from "@/utils/string-utils";
import BoosterUtils from "@/utils/booster-utils";
import Scene = Phaser.Scene;
import BaseSound = Phaser.Sound.BaseSound;
import OnceCaller from "@/utils/once-caller";

export class CampaignCommonPanel extends VerticalLongPanel {

    private shopCallback: (() => unknown) | undefined;

    private statusDto!: StatusDto;

    constructor(scene: Scene, canvas: HTMLCanvasElement, campType: CampaignType, clickSound: BaseSound | undefined, shopCallback: () => unknown,
                statClickCallback: (creatureId:string) => unknown) {
        super(scene, canvas, CampaignCommonPanel.getName(campType).toUpperCase());

        this.shopCallback = shopCallback;
        let self = this;

        PlayerStore.fetchCampaignStatus(campType).then((s: StatusDto) => {
            self.statusDto = s;
            let rulesText = TextUtils.addTextByFamily(scene, TrSpace('camp.no.more')
                + String(s.maxUsages) +  (s.maxUsages == 1? Tr('tm.used') : Tr('tms.used')) + String(s.usages) + '/' + String(s.maxUsages) + ')', 0, 85,
                '#c2c2c2', 11, 'normal', 420, Fonts.MYRIADPRO_REGULAR);
            rulesText.setVisible(s.maxUsages < 100);

            let dateText = TextUtils.addTextByFamily(scene, Tr('cmp.dates') + s.dates, 0, 115,
                '#c2c2c2', 11, 'normal', 420, Fonts.MYRIADPRO_REGULAR);

            this.addImage(scene, campType, s.details, statClickCallback);

            self.add([rulesText, dateText]);
        });

        this.addCustomButton(-100, 197,Tr('zakrit'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, () => {
            SoundUtils.play(clickSound);
        });
        this.addCustomButton(100, 197, Tr('v.magazin').toUpperCase(), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, this.shopCallback);
    }

    protected onClose(): void {

    }

    private static getName(type: CampaignType){
        switch (type) {
            case CampaignType.HERO:
                return Tr('c.hero');
            case CampaignType.GEMS_PLUS_50:
                return Tr('c.gems_plus_50');
            case CampaignType.SNOW_WORLD:
                return Tr('c.snow_world');
            case CampaignType.BOOSTER:
                return Tr('c.boosters');
            case CampaignType.PORTAL_DISCOUNT:
                return Tr('c.portal_discount');
        }
        return '';
    }

    private addImage(scene: Scene, type: CampaignType, details:string, statClickCallback: (creatureId:string) => unknown = () => {}) {
        let self = this;
        let minEmeralds;
        let minEmeralds2;
        let img;
        let silverText;
        let goldText;
        switch (type) {
            case CampaignType.HERO:
                let creatureId = details.split('|')[1];
                minEmeralds = details.split('|')[0];
                ShopStore.fetchAnyCreatureById(creatureId).then((creature: ShopCreature) => {


                    let panel = new CampaignCreaturePanel(this.scene!, -229 * CU.S, -245* CU.S, creature, statClickCallback, () => {});
                    self.add([panel]);
                })
                goldText = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('free.hero.conds').toUpperCase(), minEmeralds), 0, 0,
                    '#8dff57', 15, 'normal', 450, Fonts.MYRIADPRO_REGULAR);
                self.add([goldText]);
                break;
            case CampaignType.SNOW_WORLD:
                let hours = details.split('|')[1];
                minEmeralds = details.split('|')[0];
                let square = SpriteUtils.addSprite(scene, 0, -100, Keys.ATLAS_PROFILE, Keys.UI_ART_BROWN_BUTTON, 1);
                let check = SpriteUtils.addSprite(scene, 0, -100, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, 1);

                goldText = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('free.snow.world.conds').toUpperCase(), minEmeralds, hours), 0, 22,
                    '#adffb3', 12, 'normal', 480, Fonts.MYRIADPRO_REGULAR);
                self.add([goldText, square, check]);
                break;
            case CampaignType.PORTAL_DISCOUNT:
                minEmeralds = details.split('|')[0];
                minEmeralds2 = details.split('|')[1];
                img = SpriteUtils.addSprite(scene, 0, -130, Keys.ATLAS_PORTALS, Keys.PORTAL_P3, 1);

                silverText = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('portal.discount.cond').toUpperCase(), minEmeralds),0, -10,
                    '#ffd465', 17, 'normal', 480, Fonts.MYRIADPRO_REGULAR);
                goldText = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('portal.discount.cond2').toUpperCase(), minEmeralds2), 0, 42,
                    '#adffb3', 12, 'normal', 480, Fonts.MYRIADPRO_REGULAR);

                self.add([img, goldText, silverText]);
                break;

            case CampaignType.GEMS_PLUS_50:
                img = SpriteUtils.addSprite(scene, 0, -130, Keys.ATLAS_BANK, Keys.UI_SHOP_GEMS_5, 1);
                goldText = TextUtils.addTextByFamily(scene, StringUtils.formatString(Tr('kupi.izumrudi.i.poluchi..v.podarok2').toUpperCase()), 0, 42,
                    '#adffb3', 12, 'normal', 480, Fonts.MYRIADPRO_REGULAR);
                self.add([goldText, img]);
                break;

            case CampaignType.BOOSTER:
                img = SpriteUtils.addSprite(scene, 0, -170, Keys.ATLAS_BOOST, BoosterUtils.getIcon(BoosterType.COMPLEX_BIG),1);

                let baseText = StringUtils.formatString(Tr('booster.cond').toUpperCase())
                let secondaryText = StringUtils.formatString(Tr('booster.cond2').toUpperCase(), details)

                if(!self.statusDto.baseGiftAllowed){
                    baseText = secondaryText;
                    secondaryText = '';
                }

                silverText = TextUtils.addTextByFamily(scene, baseText,0, -60,
                    '#ffd465', 17, 'normal', 450, Fonts.MYRIADPRO_REGULAR);
                goldText = TextUtils.addTextByFamily(scene, secondaryText, 0, 42-30,
                    '#adffb3', 12, 'normal', 450, Fonts.MYRIADPRO_REGULAR);

                self.add([img, goldText, silverText]);
                break;
        }
    }

}
